<template>
    <div class="camera-row">
        <div class="panel document-panel">
            <div class="title-panel" :id="data.categoryName">
                <span class="title"><strong>{{ data.categoryName }}</strong></span>
                <span class="button-hide-show" v-if="isHiddenDocument == false" @click="handleHideDocumentPanel">-</span>
                <span class="button-hide-show" v-else @click="handleHideDocumentPanel">+</span>
            </div>
            <div class="detail-panel" v-show="!isHiddenDocument" v-for="item in data.subjects" :key="item.id">
                <CameraRowItem :item="item" :is-finished-anken="isFinishedAnken" />
            </div>
        </div>
    </div>
</template>

<script>
import CameraRowItem from './CameraRowItem.vue'

export default {
    name: 'camera-row',
    props: ['data', 'isFinishedAnken'],
    data () {
        return {
            isHiddenDocument: false
        }
    },
    components: {
        CameraRowItem
    },
    methods: {
        handleHideDocumentPanel () {
            this.isHiddenDocument = !this.isHiddenDocument
        }
    }
}
</script>

<style>
.camera-row .document-panel {
    margin-bottom: 20px;
}
.camera-row .title-panel {
    background-color: #c0b283;
    padding: 10px;
    text-align: center;
    display: inline-block;
    width: 100%;
}
.camera-row .title-panel .title {
    color: #000;
    font-weight: bold;
}
.camera-row .title-panel .button-hide-show {
    float: right;
    width: 15px;
    height: 15px;
    background: black;
    color: white;
    text-align: center;
    line-height: 13px;
}
.camera-row .document-panel .detail-panel {
    border: 1px solid #e4dec0;
}
</style>
